import { useState } from "react";
import { Loader2 } from "lucide-react";
import { http, setToken, errorText } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      setToken(data?.token);
      onLogin(data);
    } catch (err) {
      setError(errorText(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#16302B] grain relative flex items-center justify-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="relative w-full max-w-md text-white" data-testid="admin-login-form">
        <Logo variant="light" size={48} />
        <h1 className="font-display text-4xl mt-10">Journal admin</h1>
        <p className="text-white/65 text-[15px] mt-3">Sign in to write and publish insights.</p>
        <div className="mt-10 space-y-6">
          <input className="field" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          <input className="field" type="password" placeholder="Password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
        </div>
        {error && <p className="mt-6 text-[14px] text-[#F0C9A0]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-brass on-dark mt-10 w-full py-4 text-sm font-medium inline-flex items-center justify-center gap-2" data-testid="admin-login-submit-button">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Sign in
        </button>
      </form>
    </div>
  );
};
